/**
 * BondRelatedPerson — ADR-035 + ADR-129 (mapeamento factual).
 *
 * "Quem está factualmente relacionado ao Bond" — apenas Persons (família,
 * sócios, contexto). NÃO implica acesso ou autoridade — captura **estrutura
 * factual independente de autorização**.
 *
 * Crítico para:
 *   - Conflict Detection ADR-050 categoria A (cross-pessoa).
 *   - Identity Resolution ADR-035 (relação cruzada).
 *   - LivingSummary (contexto familiar/empresarial para UI).
 *
 * `status='terminated'` preserva histórico sem revogar acesso — ex-cônjuge
 * separação, ex-funcionário desligamento.
 */
export const BOND_RELATED_PERSON_STATUSES = ['active', 'terminated'];
export const BOND_RELATED_PERSON_SOURCES = [
    'declared-by-titular',
    'declared-by-operator',
    'sync-from-external',
    'inferred',
];
/**
 * Catálogo inicial de tipos de relacionamento. Cada bond.type tem subset
 * aplicável gerenciado via Capability Registry
 * class='bond-relationship-types'. Lista abaixo é union dos verticais.
 */
export const BOND_RELATIONSHIP_TYPES = [
    // Família
    'spouse',
    'ex-spouse',
    'parent',
    'mother',
    'father',
    'child',
    'son',
    'daughter',
    'sibling',
    'brother',
    'sister',
    'grandparent',
    'grandchild',
    'dependent',
    'in-law',
    // Tutela legal
    'legal-guardian',
    'court-appointed-guardian',
    'temporary-guardian',
    'emergency-contact',
    // Empresarial
    'employee',
    'employer',
    'business-partner',
    'shareholder',
    'majority-owner',
    // Cuidado
    'caregiver',
    'home-aide',
    'nurse',
    // Beneficiário
    'beneficiary',
    'guarantor',
    // Externo
    'lawyer',
    'external-counsel',
    'representative',
    // Educação
    'classmate',
    'teacher',
    // Outros
    'witness',
    'co-defendant',
    'related-to',
];
//# sourceMappingURL=related-persons.js.map